import {
  SET_CONTACTS_LOADING,
  GET_EMERGENCY_CONTACTS_SUCCESS,
  CLEAR_EMERGENCY_CONTACTS_REDUCER,
} from '../constants/ActionTypes';

const INIT_STATE = {
  contacts: [],
  loading: false,
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_EMERGENCY_CONTACTS_SUCCESS: {
      return {
        ...state,
        contacts: action.payload.contacts,
      };
    }
    case SET_CONTACTS_LOADING: {
      return {
        ...state,
        loading: action.payload.isLoading,
      };
    }
    case CLEAR_EMERGENCY_CONTACTS_REDUCER: {
      return INIT_STATE;
    }
    default: {
      return state;
    }
  }
};
